<script>
  import CheckCircleOutline from "@/components/partials/icons/CheckCircleOutline.vue";
  import QuestionMark from "@/components/partials/icons/QuestionMark.vue";
  import formatDate from "@/utils/date/format";

  export default {
    name: "Approved",
    components: {
      CheckCircleOutline,
      QuestionMark,
      BaseModal: () => import("@/components/partials/base-modal/Index.vue"),
    },
    props: {
      approvalData: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        isModalOpened: false,
      };
    },
    computed: {
      approvedAt() {
        return formatDate({
          date: this.approvalData?.approvedAt,
          options: {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          },
        });
      },
    },
  };
</script>

<template>
  <div>
    <transition name="fadeUp">
      <BaseModal
        v-if="isModalOpened"
        title="approvalInformation"
        :has-footer="false"
        @cancel="isModalOpened = false"
      >
        <div class="p-x-18 p-y-24">
          <div class="d-flex gap-6 m-b-9">
            <p class="p-base-medium text-neutral-600 text-capitalize">
              {{ $t("labels.by") }}:
            </p>
            <p class="p-base-medium text-neutral-900">
              {{ approvalData.approvedBy }}
            </p>
          </div>
          <div class="d-flex gap-6 m-b-9">
            <p class="p-base-medium text-neutral-600 text-capitalize">
              {{ $t("labels.date") }}:
            </p>
            <p class="p-base-medium text-neutral-900">
              {{ approvedAt }}
            </p>
          </div>
        </div>
      </BaseModal>
    </transition>
    <div class="d-flex align-items-center gap-3">
      <div
        class="bg-success-50 p-y-3 p-x-6 radius-16 d-flex align-items-center gap-6"
      >
        <CheckCircleOutline
          color="var(--success-700)"
          :width="12"
          :height="12"
        />
        <p class="text-success-700 p-small-medium">
          {{ $t("labels.approved") }}
        </p>
      </div>
      <div
        v-if="
          approvalData && Object.keys(approvalData).length
        "
        class="cursor-pointer bg-base-white border-full-1 border-neutral-500 radius-full icon-container
        d-flex align-items-center justify-content-center"
        @click="isModalOpened = true"
      >
        <QuestionMark width="9" height="9" />
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.icon-container
  width: 16px
  height: 16px
</style>
